import { render, staticRenderFns } from "./TailwindTableTabs.vue?vue&type=template&id=50a3c31a&"
import script from "./TailwindTableTabs.vue?vue&type=script&lang=ts&"
export * from "./TailwindTableTabs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports